module.exports = __webpack_public_path__ + "static/social-card-815b602ea056fc868329dbbf7754a41f.png";